var map = {
	"./Bronze_Emblem.png": 60547,
	"./Challenger_Emblem.png": 3362,
	"./Diamond_Emblem.png": 73381,
	"./Emerald_Emblem.png": 31069,
	"./Gold_Emblem.png": 55641,
	"./Grandmaster_Emblem.png": 58273,
	"./Iron_Emblem.png": 44961,
	"./Master_Emblem.png": 27801,
	"./Platinum_Emblem.png": 76655,
	"./Silver_Emblem.png": 6502,
	"./Unranked_Emblem.png": 80087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32778;